import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the runs sub-tree (register at `/production-packconv/runs`,
 * detail at `/production-packconv/runs/$runId`) — mirrors the app-root
 * `_authenticated.tsx` + `_authenticated/` nesting pattern and
 * `silo-counts/counts.tsx`'s identical precedent. No chrome of its own; the parent
 * `production-packconv.tsx` layout already renders the tab strip. */
export const Route = createFileRoute('/_authenticated/production-packconv/runs')({
  component: () => <Outlet />,
});
